import { Box } from '@mui/system';
import React from 'react';

const FlexHeaderContainer = ({ children }) => {
  return (
    <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> 
      {children}
    </Box>
  );
};

export default FlexHeaderContainer;